import "./assets/css/main.scss";

import { locator } from "@core/di";
import { DecouplerContext } from "@policoders/di";
import ReactDOM from "react-dom/client";

import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <DecouplerContext.Provider value={locator}>
    <App />
  </DecouplerContext.Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
